import enDocuments from './en';
import ruDocuments from './ru';

export default {
  en: {
    ...enDocuments,
  },
  ru: {
    ...ruDocuments,
  },
};
